import Joi from 'joi'

import errorsResolver from '../../../../validation/schemeUtils'

const NUMBER_LENGTH = 50

export const transferSaledGoHranModalSheme = Joi.object({
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9]*$'))
    .required()
    .error(errorsResolver({
      max: `Номер документа должен быть до ${NUMBER_LENGTH} символов`,
      required: `Номер документа обязательное поле`,
      pattern: 'Номер документа должен быть числом',
    })),
  transferDate: Joi.date()
    .required()
    .iso()
    .error(errorsResolver({
      required: `Дата обязательное поле`,
      dateFormat: `Некорректная дата`
    }))
})
